import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { FaArrowLeftLong } from "react-icons/fa6";
import { setPollEnable } from "../../redux/slices/tempSlice";
import { PostCrop } from "./PostCrop";
import styles from "./PostWrapper.module.scss";
import SelectedImage from "./SelectedImage";
import TextBox from "./TextBox";
import UploadSection from "./UploadSection";
import WebcamCapture from "../Stories2/WebcamCapture";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { validateMediaFile } from "../../utils/fileValidation";

const PostWrapper = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const fileData = location.state?.fileData || null;
  const dispatch = useDispatch();
  const { pollObj } = useSelector((s) => s.temp);
  // Image Data
  const [imagesArray, setImagesArray] = useState([]);
  const image = useRef();

  // Text Box
  const [text, setText] = useState("");
  const [bgColor, setBgColor] = useState({ r: 0, g: 0, b: 0, a: 1 });

  // Components
  const [textBox, setTextBox] = useState(false);
  const [selectedImageShow, setSelectedImageShow] = useState(false);
  const [cropContShow, setCropContShow] = useState(false);
  const [uploadSection, setUploadSection] = useState(false);
  const [openWebCame, setOpenWebCame] = useState(false);

  // Cleanup camera and modals when component unmounts or user navigates away
  useEffect(() => {
    return () => {
      setOpenWebCame(false);
      setTextBox(false);
      setSelectedImageShow(false);
      setCropContShow(false);
      setUploadSection(false);
    };
  }, []);

  useEffect(() => {
    if (location.state?.isTextPost) {
      setTextBox(true);
      setText(location.state.originalText || "");
      setBgColor(location.state.originalBgColor || { r: 0, g: 0, b: 0, a: 1 });
      return;
    }
    if (fileData === null) return;

    const files = Array.isArray(fileData) ? fileData : [fileData];
    for (const f of files) {
      const validation = validateMediaFile(f);
      if (!validation.valid) {
        toast.error(validation.error);
        return;
      }
    }

    const first = files[0];
    const isVideo = (first?.type && first.type.startsWith("video")) || first?.type === "video/mp4";
    if (isVideo) {
      setUploadSection(true);
      setImagesArray(files);
    } else {
      setSelectedImageShow(true);
      setImagesArray(files);
    }
  }, [fileData, location.state]);

  useEffect(() => {
    const handlePopState = () => {
      setOpenWebCame(false);
    };
    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, []);

  const handleFileInputChange = (e) => {
    const file = e.target.files;

    if (file && file.length > 0) {
      const filesArr = Array.from(file);
      for (const f of filesArr) {
        const validation = validateMediaFile(f);
        if (!validation.valid) {
          toast.error(validation.error);
          e.target.value = null;
          return;
        }
      }

      const isVideo = filesArr.some(f => f.type?.startsWith("video") || f.type === "video/mp4");
      if (isVideo) {
        setUploadSection(true);
        setImagesArray(filesArr);
      } else {
        setImagesArray(filesArr);
        setSelectedImageShow(true);
      }
    }

    e.target.value = null;
  };
  const Controls = () => {
    return (
      <div className={styles.Controls}>
        <h1>{pollObj.enablePoll ? "Create Poll" : "Update fameo-X"} </h1>
        <h4>Drag & Drop your image or video</h4>
        <h4>Or</h4>
        <div className={styles.buttonContainer}>
          <button className={styles.button} onClick={() => setTextBox(true)}>
            Text
          </button>
          <button
            className={styles.button}
            onClick={() => toast.info("VMagz Coming Soon...")}
          >
            VMagz
          </button>
          <button
            className={styles.button}
            onClick={() => setOpenWebCame(true)}
          >
            Camera
          </button>
          <button
            className={styles.button}
            onClick={() => image.current?.click()}
          >
            Upload From Computer
          </button>
        </div>
        <input
          type="file"
          multiple
          ref={image}
          accept=".jpg,.jpeg,.png,.webp,.gif,.svg,.mp4,.mov,.webm,.ogg,image/jpeg,image/png,image/webp,image/gif,video/mp4,video/quicktime,video/webm"
          style={{ display: "none" }}
          onChange={handleFileInputChange}
        />
      </div>
    );
  };

  return (
    <div className={styles.PostWrapperOuter}>
      <div className={styles.PostWrapperInner}>
        {!textBox &&
          !uploadSection &&
          !selectedImageShow &&
          !cropContShow &&
          !openWebCame && (
            <button
              type="button"
              className={styles.CloseBtn}
              onClick={() => {
                dispatch(setPollEnable(false));
                setOpenWebCame(false);
                navigate("/Home");
              }}
            >
              <FaArrowLeftLong />
              <span>Back</span>
            </button>
          )}



        {!textBox && !uploadSection && !selectedImageShow && !cropContShow && (
          <Controls />
        )}
        {textBox && (
          <TextBox
            {...{
              setImagesArray,
              setTextBox,
              setUploadSection,
              text,
              setText,
              bgColor,
              setBgColor,
            }}
          />
        )}
        {openWebCame && (
          <WebcamCapture
            setOpenWebCame={setOpenWebCame}
            setImageArray={setImagesArray}
            setOpenCrop={setCropContShow}
          />
        )}

        {selectedImageShow && (
          <SelectedImage
            {...{
              setSelectedImageShow,
              // setUploadSection,
              imagesArray,
              setImagesArray,
              setCropContShow,
            }}
          />
        )}

        {cropContShow && (
          <PostCrop
            {...{
              imagesArray,
              setImagesArray,
              setCropContShow,
              setSelectedImageShow,
              setUploadSection,
            }}
          />
        )}

        {uploadSection && (
          <UploadSection
            {...{
              setUploadSection,
              setSelectedImageShow,
              imagesArray,
              setImagesArray,
              text,
              setTextBox,
              setCropContShow,
            }}
          />
        )}
      </div>
    </div>
  );
};

export default PostWrapper;
